import {useFieldArray, useFormContext} from "react-hook-form";

import {MultiServiceSelect} from "@/components/multiServiceSelect/MultiServiceSelect.tsx";
import {MonitoringServiceType, ServiceGroup, ServiceTag} from "@/lib/types/checks.ts";

interface SelectServiceInputProps {
  monitoringServiceTypes: ServiceGroup[];
  excludeMonitoringServiceType?: MonitoringServiceType;
  tags: ServiceTag[];
  name: string;
  skipRequest?: boolean;
  excludeIds?: number[];
}

export const SelectServiceBoxes = ({
  monitoringServiceTypes,
  excludeMonitoringServiceType,
  tags,
  name,
  skipRequest,
  excludeIds,
}: SelectServiceInputProps) => {
  const {control, watch} = useFormContext();
  const defaultValue = watch(name);
  const {replace, append} = useFieldArray({control, name});

  return (
    <MultiServiceSelect
      monitoringServiceTypes={monitoringServiceTypes}
      excludeMonitoringServiceType={excludeMonitoringServiceType}
      tags={tags}
      defaultValue={defaultValue}
      skipRequest={skipRequest}
      excludeIds={excludeIds}
      onAppend={append}
      onReplace={replace}
    />
  );
};
